import { render, staticRenderFns } from "./recover-password-channel.vue?vue&type=template&id=37bf0e04&scoped=true&"
import script from "./recover-password-channel.vue?vue&type=script&lang=js&"
export * from "./recover-password-channel.vue?vue&type=script&lang=js&"
import style0 from "./recover-password-channel.vue?vue&type=style&index=0&id=37bf0e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf0e04",
  null
  
)

export default component.exports